import React, { useState, useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { settingService } from "../../../services/extensions";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

const AbsenceCodeForm = ({ onClose }) => {
  const [legalEntities, setLegalEntities] = useState(null);

  useEffect(() => {
    getLegalEntity();
  }, []);

  const getLegalEntity = () => {
    settingService.getLegalEntity().then((resp) => {
      setLegalEntities(resp.data.data);
    });
  };
  const formik = useFormik({
    initialValues: {
      code: "",
      title: "",
      location: null,
    },
    validate: (data) => {
      let errors = {};
      if (!data.location) {
        errors.location = "Location is required.";
      }
      if (!data.code) {
        errors.code = "Code is required.";
      }
      if (!data.title) {
        errors.title = "Title is required.";
      }

      return errors;
    },
    onSubmit: (data) => {
      let param = {
        code: data.code,
        title: data.title,
        locationID: data.location.id,
      };
      createLeaveAbsenceCode(param);
      formik.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const createLeaveAbsenceCode = (data) => {
    try {
      settingService.addLeaveAbsenceCode(data).then(
        (resp) => {
          toast.success("New Absence Code added");
          onClose();
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to add new Absence Code");
    }
  };

  const absenceCodeForm = (
    <Fieldset>
      <form className="p-fluid p-grid" onSubmit={formik.handleSubmit} autoComplete="off"
      >
        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2 mr-4">
            <strong>Location: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                {/* <InputText
                  id="location"
                  name="location"
                  value={
                    formik.values.location.charAt(0).toUpperCase() +
                    formik.values.location.slice(1)
                  }
                  onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("location"),
                  })}
                /> */}
                <Dropdown filter id="location" name="location" appendTo="self" placeholder="Select a location" options={legalEntities} value={formik.values.location} onChange={formik.handleChange} optionLabel="code"
                  className={classNames({
                    "p-invalid": isFormFieldValid("location"),
                  })} />
              </span>
              {getFormErrorMessage("location")}
            </span>
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2 mr-4">
            <strong>Code: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <InputText id="code" name="code" value={formik.values.code} onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("code"),
                  })}
                />
              </span>
              {getFormErrorMessage("code")}
            </span>
          </div>
        </div>

        <div className="formgrid grid">
          <div className="field col-1 mt-1"></div>
          <div className="field col-3 mt-2 mr-4">
            <strong>Title: </strong>
          </div>
          <div className="field col-6">
            <span className="p-mt-4 p-input-icon-right">
              <span className="p-float-label">
                <InputText id="title" name="title" value={formik.values.title.charAt(0).toUpperCase() + formik.values.title.slice(1)} onChange={formik.handleChange}
                  className={classNames({
                    "p-invalid": isFormFieldValid("title"),
                  })}
                />
              </span>
              {getFormErrorMessage("title")}
            </span>
          </div>
        </div>

        <div className="formgrid grid" style={{ paddingTop: "20px" }}>
          <div className="field col-3"></div>
          <div className="field col-4">
            <Button className="p-button-rounded p-button-secondary p-mt-2" type="button" label="Cancel" icon="pi pi-times" onClick={onClose} />
          </div>
          <div className="field col-4">
            <Button className="p-button-rounded p-button-primary p-mt-2" type="submit" label="Save" icon="pi pi-save" />
          </div>
        </div>
      </form>
    </Fieldset>
  );

  return <React.Fragment>{absenceCodeForm}</React.Fragment>;
};

export default AbsenceCodeForm;
